<div>
  <div>
    <img alt="" src="/assets/images/dashboard/Electronic-manuals.png" style="BORDER: 0px solid; width: 100%;">
  </div>
  <div class="textContainer" >
    <p class="parts-catalogue-text"><mibp-resource-string key="Dashboard_PartsCatalogueText"></mibp-resource-string></p>    
    <button type="button" class="my-button" (click)="onclick()"><mibp-resource-string key="Dashboard_PartsCatalogueButtonText"></mibp-resource-string></button>
  </div>
</div>
